import React, { Component } from 'react';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import Link from '../../../../../components/ZUILib/Link';
import pdfUtil from '../../../../../utils/PDFUtil';
import StatementPrintAndDownload from '../StatementPrintAndDownload';
import { constDownload, constPrint, constSendMail } from '../../../../../utils/clientConstant';
import { errorStrings } from '../../../../../utils/errorStrings';
import commonUtil from '../../../../../utils/commonUtil';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import { sendMail } from '../../actions';

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = 'accountstatus';
class AccountPartialTransfer extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.eventId;
    this.state = {
      transferenceSummary: null,
      transferenceDetails: null,
      emailSendStatus: null,
    };
  }

  componentDidMount() {
    this.props.getAccountPartialTransferDetails();
  }

  updateData(partialTransferData) {
    this.setState({
      transferenceSummary: partialTransferData.transferenceInfo.transferenceSummary,
      transferenceDetails: partialTransferData.transferenceInfo.transferenceDetails,
    });
  }

  getStatementDetailsForDownload = () => {
    this.printDownloadMail(constDownload);
  }
  getStatementDetailsForPrint = () => {
    this.printDownloadMail(constPrint);
  }
  getStatementDetailsForSendMail = () => {
    this.printDownloadMail(constSendMail);
  }
  accountStatementSendMail = (fileName, data) => {
    const emailId = !commonUtil.isObjectEmpty(this.props.user) && this.props.user.result && this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status === 'success') {
        this.setState({ emailSendStatus: { isSent: true, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailsent.message') } });
      } else {
        this.setState({ emailSendStatus: { isSent: false, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailfailed.message') } });
      }
    });
  }

  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }
  printDownloadMail = (type) => {
    if (type === constSendMail) {
      const mailContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDomForMail(mailContent, 'accountStatement', this.accountStatementSendMail);
    } else if (type === constDownload) {
      const downloadableContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDom(downloadableContent, ('accountstatus_' + this.eventId));
    } else if (type === constPrint) {
      const printContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate}><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDomForPrint(printContent, pageName);
    }
  }
  /*eslint-disable*/
  onSortChange = (type) => {
    const transferenceDetails = this.state.transferenceDetails;
    let sortedData = null;
    sortedData = _.sortBy(transferenceDetails, (data) => {
      return data[type];
    });
    if (this.state['sort_' + type]) {
      if (this.state['sort_' + type] === 'asc') {
        this.setState({ ['sort_' + type]: 'desc' });
        sortedData.reverse();
      } else {
        this.setState({ ['sort_' + type]: 'asc' });
      }
    } else {
      this.setState({ ['sort_' + type]: 'desc' });
      sortedData.reverse();
    }
    this.setState({ transferenceDetails: sortedData });
  }
  rediectToPage = () => {
    browserHistory.push(commonUtil.routeTo(applicationRoutes.accountStatus, { eventID: this.props.eventId }));
  }
  /*eslint-enable*/


  render() {
    const { transferenceSummary, transferenceDetails } = this.state;

    const DownloadIcon = {
      route: '',
    };
    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => { this.setState({ emailSendStatus: null }); },
    };

    const RegresarLink = {
      text: 'Regresar',
      children: 'Regresar',
      cssClass: 'lightLink size-Medium',
      onClickHandler: this.rediectToPage,
    };
    const partialWebRow = function (data, index) {
      const number = data.number.replace(/.(?=.{4})/g, 'x');
      return (
        <tr key={index}>
          <td className="dat">{commonUtil.formatDate(data.date, 'dd/mm/yyyy')}</td>
          <td>{data.storeName}</td>
          <td className="text-center">{data.userName}</td>
          <td className="detinity">{data.transferenceMethod}
            <p className="numMoney">{number}</p>
          </td>
          <td className="text-center">-{commonUtil.getCurrency(data.commission)}</td>
          <td>-{commonUtil.getCurrency(data.amountTransferred)}</td>
        </tr>
      );
    };

    const sortUpIcon = (<i className="iClass icon-flecha_filtros_arriba filter-arrow" aria-hidden="true" />);
    const sortDownIcon = (<i className="iClass icon-flecha_filtros_abajo filter-arrow" aria-hidden="true" />);


    return (
      <div className="row">
        <div className="adminAccountStateContainer">
          <div className="adminContainer detailState">
            <div className="row">
              <div className="col-md-12 barInfoGift shadowSquare">
                <div className="col-md-5">
                  <p className="title">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label1')}</p>
                  <div className="separator" />
                </div>
                {!_.isEmpty(transferenceSummary) ? <React.Fragment>
                  <div className="col-md-2 text-center">
                    <p className="concept">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label3')}</p>
                    <p className="val">{transferenceSummary.totalTransactionToMonedero}</p>
                    <div className="separator" />
                  </div>
                  <div className="col-md-3 text-center">
                    <p className="concept">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label4')}</p>
                    <p className="val">{transferenceSummary.totalTransactionsToBank}</p>
                    <div className="separator" />
                  </div>
                  <div className="col-md-2 text-right">
                    <p className="concept">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label5')}</p>
                    <p className="val cancel">-{commonUtil.getCurrency(transferenceSummary.totalTransferredAmount)}</p>
                  </div>
                </React.Fragment> : null}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="toolsLink text-right">
                  <Link rrLink={DownloadIcon} >
                    <i className="icon-correo" onClick={this.getStatementDetailsForSendMail} aria-hidden="true" />
                  </Link>
                  <Link rrLink={DownloadIcon} >
                    <i className="icon-descarga" onClick={this.getStatementDetailsForDownload} aria-hidden="true" />
                  </Link>
                  <Link rrLink={DownloadIcon} >
                    <i className="icon-imprimir" onClick={this.getStatementDetailsForPrint} aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>
            {this.state.emailSendStatus ?
              <React.Fragment>
                {this.state.emailSendStatus.isSent ?
                  <div className="alertSuccess" > <i className="icon-check" />
                    <p>{this.state.emailSendStatus.resMsg}</p>
                    <Link linkJSON={emailSendLink} />
                  </div> :
                  <div className="alertError" > <i className="icon-tache2" />
                    <p>{this.state.emailSendStatus.resMsg}</p>
                    <Link linkJSON={emailSendLink} />
                  </div>}
              </React.Fragment> : null}
          </div>
        </div>

        <div className="adminAccountStateContainer adminAccountStateContainer--custom bgGray">
          {!_.isEmpty(transferenceDetails) ?
            <div className="adminContainer">
              <div className="row">
                <div className="col-md-12 shadowSquare">
                  <div className="col-md-12">
                    <h2 className="titleModule">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label2')}</h2>
                  </div>
                  <div className="col-md-12">
                    <table className="cTable bottomLine infoListGifts">
                      <thead>
                        <tr>
                          <th><span onClick={() => this.onSortChange('date')}>{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel1')}{/*eslint-disable*/ this.state.sort_date ? (this.state.sort_date === 'desc' ? sortDownIcon : sortUpIcon) : sortUpIcon/*eslint-enable*/}</span></th>
                          <th><span onClick={() => this.onSortChange('transferenceMode')}>{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel2')}{/*eslint-disable*/this.state.sort_transferenceMode ? (this.state.sort_transferenceMode === 'desc' ? sortDownIcon : sortUpIcon) : sortUpIcon/*eslint-enable*/}</span></th>
                          <th className="text-center">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel3')}</th>
                          <th><span onClick={() => this.onSortChange('transferenceMethod')}>&nbsp;&nbsp;{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel6')}{/*eslint-disable*/this.state.sort_transferenceMethod ? (this.state.sort_transferenceMethod === 'desc' ? sortDownIcon : sortUpIcon) : sortUpIcon/*eslint-enable*/}</span></th>
                          <th className="text-center"><span onClick={() => this.onSortChange('commission')}>{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel4')}{/*eslint-disable*/this.state.sort_commission ? (this.state.sort_commission === 'desc' ? sortDownIcon : sortUpIcon) : sortUpIcon/*eslint-enable*/}</span></th>
                          <th><span onClick={() => this.onSortChange('amountTransferred')}>{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel5')}{/*eslint-disable*/this.state.sort_amountTransferred ? (this.state.sort_amountTransferred === 'desc' ? sortDownIcon : sortUpIcon) : sortUpIcon/*eslint-enable*/}</span></th>
                        </tr>
                      </thead>
                      <tbody className="listPartial">
                        {transferenceDetails ? transferenceDetails.map(partialWebRow) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div> : errorStrings.noRecordsFound}
          <div className="adminContainer footerActions">
            <div className="row">
              <Link linkJSON={RegresarLink} ><i className="iconLeft icon-flecha_light_izq" />Regresar</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default AccountPartialTransfer;
